'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.submitMakeOffer = exports.getUiMakeOffer = exports.MAKE_OFFER_SUCCESS = exports.MAKE_OFFER_REQUEST = exports.MAKE_OFFER_FAIL = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;

var _modal = require('./modal');

var _reselect = require('reselect');

var _user = require('./user');

var _enums = require('../../enums');

var _sendSellerMessage = require('./sendSellerMessage');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Action Types */
var MAKE_OFFER_FAIL = exports.MAKE_OFFER_FAIL = 'la/ui/makeOffer/FAIL';
var MAKE_OFFER_REQUEST = exports.MAKE_OFFER_REQUEST = 'la/ui/makeOffer/REQUEST';
var MAKE_OFFER_SUCCESS = exports.MAKE_OFFER_SUCCESS = 'la/ui/makeOffer/SUCCESS';

// reducer
var DEFAULT_STATE = {
    error: false,
    errorMessage: null,
    modalType: _enums.modalTypes.BUY_NOW,
    offerPrice: 0,
    submitted: false,
    success: false
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        case MAKE_OFFER_REQUEST:
            return (0, _extends3.default)({}, state, {
                error: false,
                errorMessage: null,
                submitted: true,
                success: false
            });
        case MAKE_OFFER_SUCCESS:
            return (0, _extends3.default)({}, state, {
                submitted: false,
                success: true
            });
        case MAKE_OFFER_FAIL:
            return (0, _extends3.default)({}, state, {
                error: true,
                errorMessage: action.payload,
                submitted: false,
                success: false
            });
        case _modal.OPEN_BUY_NOW_MODAL:
            return (0, _extends3.default)({}, state, {
                itemId: action.payload.itemId,
                modalType: action.payload.modalType,
                offerPrice: action.payload.offerPrice
            });
        case _modal.DISMISS_MODAL:
            return DEFAULT_STATE;
        default:
            return state;
    }
}

/* SELECTORS */
var stateSelector = function stateSelector(state) {
    return state.ui.makeOffer;
};

var getUiMakeOffer = exports.getUiMakeOffer = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state;
});

/* ACTION CREATORS */
var submitMakeOffer = exports.submitMakeOffer = function submitMakeOffer(_ref) {
    var address = _ref.address,
        catalogId = _ref.catalogId,
        currency = _ref.currency,
        formatNumber = _ref.formatNumber,
        highEistimate = _ref.highEistimate,
        itemId = _ref.itemId,
        lowEistimate = _ref.lowEistimate,
        message = _ref.message,
        buyNow = _ref.buyNow,
        offer = _ref.offer,
        premium = _ref.premium,
        saledate = _ref.saledate,
        sellerId = _ref.sellerId,
        shipping = _ref.shipping,
        title = _ref.title;
    return function () {
        var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch, getState) {
            var state, uiState, userData, formatCurrencyObject, offerMessage, messageText, subjectStart, subject, messageDetails;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.prev = 0;
                            state = getState();
                            uiState = getUiMakeOffer(state);
                            userData = (0, _user.getUserData)(state);
                            formatCurrencyObject = { currency: currency, maximumFractionDigits: 0, minimumFractionDigits: 0, style: currency };
                            offerMessage = buyNow === offer ? 'wants to buy your item' : 'sent you an offer';
                            messageText = '\n' + userData.firstName + ' ' + userData.lastName + ' (' + address.city + ', ' + address.state + ', ' + address.country + ') ' + offerMessage + '!\nPlease reply to this message to accept or reject this offer.\n\n\nOffer: ' + formatNumber(offer, formatCurrencyObject) + '\n\nBuy Now Price: ' + formatNumber(buyNow, formatCurrencyObject) + '\n\nEstimate: ' + formatNumber(lowEistimate, formatCurrencyObject) + ' - ' + formatNumber(highEistimate, formatCurrencyObject) + '\n\n\n\nMessage: ' + message + '\n\n\n\nAddress:\n' + userData.firstName + ' ' + userData.lastName + '\n' + address.address + '\n' + address.address2 + '\n' + address.city + ', ' + address.state + ' ' + address.zip + '\n' + address.country + '\n\n\nReference:\nBidder ID: ' + userData.bidderId + '\n\nItem ID: ' + itemId + '\n\nSale Date: ' + saledate + '\n\nCatalog ID: ' + catalogId + '\n\nPremium: ' + formatNumber(premium, formatCurrencyObject) + '\n\nShipping: ' + formatNumber(shipping, formatCurrencyObject) + '\n';
                            subjectStart = uiState.modalType === _enums.modalTypes.BUY_NOW ? 'Buy Now' : 'Make An Offer';
                            subject = subjectStart + ' - ' + title;
                            messageDetails = {
                                catalogId: catalogId,
                                itemId: itemId,
                                message: messageText,
                                sellerId: sellerId,
                                subject: subject
                            };


                            dispatch({
                                payload: messageDetails,
                                type: MAKE_OFFER_REQUEST
                            });
                            _context.next = 13;
                            return dispatch((0, _sendSellerMessage.submitSendSellerMessage)(messageDetails));

                        case 13:

                            dispatch({
                                meta: { actionTime: Date.now() },
                                payload: itemId,
                                type: MAKE_OFFER_SUCCESS
                            });
                            _context.next = 19;
                            break;

                        case 16:
                            _context.prev = 16;
                            _context.t0 = _context['catch'](0);

                            dispatch({
                                error: true,
                                meta: { itemId: itemId },
                                payload: _context.t0,
                                type: MAKE_OFFER_FAIL
                            });

                        case 19:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, undefined, [[0, 16]]);
        }));

        return function (_x3, _x4) {
            return _ref2.apply(this, arguments);
        };
    }();
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/makeOffer.js
// module id = 6L4D
// module chunks = 60